import { createAsyncThunk } from '@reduxjs/toolkit';
import { UsersAPI } from '@/api';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import {
  IGetAdminsListDTO,
  IAdminsListResponse,
  IAdminDetailsDTO,
  IUsersListResponse,
  IGetUsersListDTO,
  IUserAuthData,
} from '@/models/users.model';
import { IAdminProfileResponse } from '@/models/admins.model';
import { USERS_LIST_SLICE_NAME } from './models';
import { PARTNERS_LIST_SLICE_NAME } from '@/modules/Partners';

export const getAdminsList = createAsyncThunk<
  IAdminsListResponse,
  IGetAdminsListDTO,
  { serializedErrorType: IApiError }
>(
  `${USERS_LIST_SLICE_NAME}/getAdminsList`,
  async (data) => {
    const response = await UsersAPI.getAdminsList(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const getUsersList = createAsyncThunk<IUsersListResponse, IGetUsersListDTO, { serializedErrorType: IApiError }>(
  `${USERS_LIST_SLICE_NAME}/getUsersList`,
  async (data) => {
    const response = await UsersAPI.getUsersList(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const getAdminDetails = createAsyncThunk<IAdminProfileResponse, string, { serializedErrorType: IApiError }>(
  `${USERS_LIST_SLICE_NAME}/getAdminDetails`,
  async (id) => {
    const response = await UsersAPI.getAdminDetails(id);
    return response.data?.data;
  },
  { serializeError: formatApiError },
);

export const updateAdminDetails = createAsyncThunk<
  IAdminProfileResponse,
  IAdminDetailsDTO,
  { serializedErrorType: IApiError }
>(
  `${USERS_LIST_SLICE_NAME}/updateAdminDetails`,
  async (id) => {
    const response = await UsersAPI.updateAdminDetails(id);
    return response.data?.data?.[0];
  },
  { serializeError: formatApiError },
);

export const toggleActiveUser = createAsyncThunk<IUsersListResponse, string, { serializedErrorType: IApiError }>(
  `${USERS_LIST_SLICE_NAME}/toggleActiveUser`,
  async (id: string) => {
    const response = await UsersAPI.toggleActiveUser(id);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const deleteAdmin = createAsyncThunk<IAdminProfileResponse, string, { serializedErrorType: IApiError }>(
  `${USERS_LIST_SLICE_NAME}/deleteAdmin`,
  async (id) => {
    const response = await UsersAPI.deleteAdmin(id);
    return response.data?.data;
  },
  { serializeError: formatApiError },
);

export const createAdmin = createAsyncThunk<
  IAdminProfileResponse,
  IAdminDetailsDTO,
  { serializedErrorType: IApiError }
>(
  `${USERS_LIST_SLICE_NAME}/createAdmin`,
  async (data) => {
    const response = await UsersAPI.createAdmin(data);
    return response.data?.data?.[0];
  },
  { serializeError: formatApiError },
);

export const getUserAuthData = createAsyncThunk<IUserAuthData, string, { serializedErrorType: IApiError }>(
  `${PARTNERS_LIST_SLICE_NAME}/getUserAuthData`,
  async (id) => {
    const response = await UsersAPI.getUserAuthData(id);
    return response.data;
  },
  { serializeError: formatApiError },
);
